// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__36BkW","paramInput":"JobSimulator_paramInput__2n9co","input":"JobSimulator_input__1gMee"};